import { Controller } from "@hotwired/stimulus"

// This controller is only used on the home page to handle scroll behavior
export default class extends Controller {
  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.handleScroll)
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)
  }

  handleScroll() {
    const scrollY = window.scrollY
    const threshold = window.innerHeight - 100
    const border = this.element.querySelector("[data-navbar-border]")

    if (scrollY > threshold) {
      this.element.classList.add("bg-black")
      if (border) {
        border.classList.remove("border-white")
        border.classList.add("border-transparent")
      }
    } else {
      this.element.classList.remove("bg-black")
      if (border) {
        border.classList.remove("border-transparent")
        border.classList.add("border-white")
      }
    }
  }
}
